module.exports = __webpack_public_path__ + "static/media/ITBO03.91338e3a.jpg";